<template>
  <v-container>
    <v-row class="white">
      <v-col class="display-1 ma-3">TUTORIALES</v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="6"
        xl="4"
        v-for="(video, i) in videos"
        :key="i"
      >
        <v-card width="100%">
          <v-container>
            <h2 class="subtitle-1 mb-0">{{ video.title }}</h2>
            <video width="100%" height="100%" controls>
              <source :src="video.url" type=video/mp4>
            </video>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      videos: [
        {
          title: "Presentación de la App",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F1.%20Prosic.App_Presentaci%C3%B3nApp.mp4?alt=media&token=51d752df-cf76-4baf-9461-f6f7b6ca5466"
        },
        {
          title: "Pasos previos para el uso de la app de inspección",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F2.Pasos%20previos%20para%20el%20uso%20de%20la%20app%20de%20inspecci%C3%B3n.mp4?alt=media&token=537f9eb9-241a-4703-88a9-64a26da25af0"
        },
        {
          title: "¿Cómo acceder a la App de Inspección?",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F3.%C2%BFC%C3%B3mo%20acceder%20a%20la%20App%20de%20Inspecci%C3%B3n-%20(tutorial%20paso%20a%20paso).mp4?alt=media&token=8101c5cc-6fac-45e1-8fcc-45e54e551ddd"
        },
        {
          title: "Pestañas de la App de Inspección ",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F4.Pesta%C3%B1as%20de%20la%20App%20de%20Inspecci%C3%B3n%20(descripci%C3%B3n-explicaci%C3%B3n).mp4?alt=media&token=4acc09d3-f6ff-4aa0-9acf-d667c93f123c"
        },
        {
          title: "¿Cómo llenar un check list de entregas?",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F5.%C2%BFC%C3%B3mo%20llenar%20un%20check%20list%20de%20entregas_.mp4?alt=media&token=9f569e78-bcb3-48a3-8e99-be6ff74411cc"
        },
        {
          title: "¿Cómo llenar un check list para recolección?",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F6.%C2%BFC%C3%B3mo%20llenar%20un%20check%20list%20para%20recolecci%C3%B3n_.mp4?alt=media&token=e11bcda6-159e-4cb0-bca6-29d36ecfb63b"
        },
        {
          title: "Revisar Reportes en la App de Inspección",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F7.Revisar%20Reportes%20en%20la%20App%20de%20Inspecci%C3%B3n%20(tutorial%20paso%20a%20paso).mp4?alt=media&token=336e2748-a392-43a0-9bcd-73b3282acbe4"
        },
        {
          title: "Histórico de Reportes en la App de Inspección",
          url:
            "https://firebasestorage.googleapis.com/v0/b/prosic-management.appspot.com/o/tutorials%2F8.Hist%C3%B3rico%20de%20Reportes%20en%20la%20App%20de%20Inspecci%C3%B3n%20(tutorial%20paso%20a%20paso).mp4?alt=media&token=3de06869-6dbf-4992-b346-e0f9ddca1147"
        }
      ]
    };
  },
  methods: {
    ...mapActions("user", ["changeVideoTutorial"])
  },
  computed: {
    ...mapState("user", ["showTutorialVideo"])
  }
};
</script>
